/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import { useForm } from "react-hook-form";
import axios from "axios";
import Swal from "sweetalert2";
import ScrollToTop from "../../../../../components/scrollToTop/scrollToTop";
import "./style.css";

function AddUser({ handleClick }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    password: "",
    password_confirm: "",
    role_id: 0.0,
  });

  const handleFormSubmit = async (data) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_URL_BACKEND}/api/v1/users/create`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem("token")}`,
          },
        }
      );

      if (res.data.code === 1) {
        Swal.fire("Creado!", "El usuario ha sido creado.", "success");
        handleClick("Usuarios");
      }
    } catch (error) {
      console.error(error);
      if (error.response && error.response.data) {
        if (error.response.data.message === "Unique Constraint Error") {
          Swal.fire("Error", "el email ya esta registrado", "warning");
        }
      } else {
        Swal.fire("Error", "Hubo un error", "error");
      }
    }
  };

  const handleFormData = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  return (
    <>
      <ScrollToTop />
      <div className="card-body">
        <div className="row">
          <div className="col-sm-12">
            <form
              className="form-horizontal fv-form fv-form-bootstrap"
              acceptCharset="UTF-8"
              id="formValidation"
              encType="multipart/form-data"
              noValidate="novalidate"
              onSubmit={handleSubmit(handleFormSubmit)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  e.preventDefault();
                }
              }}
            >
              <div className="rootwizard">
                <ul className="nav nav-pills">
                  <li className="nav-item">
                    <a className="nav-link active" data-toggle="tap">
                      General
                    </a>
                  </li>
                </ul>
                <br />
                <div className="tab-content">
                  <div className="tab-pane fade show active" id="tab1">
                    <div className="form-group row mb-3 ">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="first_name"
                      >
                        Nombre <span style={{ color: "#fa0073" }}>*</span>
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="first_name"
                          className={`form-control ${
                            errors.first_name?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.first_name?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.first_name?.type === "validate"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.first_name?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.first_name?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="Nombre"
                          name="first_name"
                          type="text"
                          data-fv-field="first_name"
                          {...register("first_name", {
                            required: "El campo es requerido",
                            pattern: {
                              value: /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]+$/,
                              message: "Ingresa un Nombre valido",
                            },
                            maxLength: 255,
                            minLength: 3,
                          })}
                          onChange={handleFormData}
                        />
                        {errors.first_name?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="first_name"
                            data-fv-result="INVALID"
                          >
                            {errors.first_name.message}
                          </small>
                        )}
                        {errors.first_name?.type === "pattern" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="first_name"
                            data-fv-result="INVALID"
                          >
                            {errors.first_name.message}
                          </small>
                        )}

                        {errors.first_name?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="first_name"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                        {errors.first_name?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="first_name"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group row mb-3 ">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="last_name"
                      >
                        Apellido <span style={{ color: "#fa0073" }}>*</span>
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="last_name"
                          className={`form-control ${
                            errors.last_name?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.last_name?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.last_name?.type === "validate"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.last_name?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.last_name?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="Apellido"
                          name="last_name"
                          type="text"
                          data-fv-field="last_name"
                          {...register("last_name", {
                            required: "El campo es requerido",
                            pattern: {
                              value: /^[a-zA-ZáéíóúÁÉÍÓÚüÜñÑ\s]+$/,
                              message: "Ingresa un apellido valido",
                            },
                            maxLength: 255,
                            minLength: 3,
                          })}
                          onChange={handleFormData}
                        />
                        {errors.last_name?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="last_name"
                            data-fv-result="INVALID"
                          >
                            {errors.last_name.message}
                          </small>
                        )}
                        {errors.last_name?.type === "pattern" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="last_name"
                            data-fv-result="INVALID"
                          >
                            {errors.last_name.message}
                          </small>
                        )}

                        {errors.last_name?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="last_name"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                        {errors.last_name?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="last_name"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            3 y 255 caracteres
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group row mb-3 ">
                      <label className="col-sm-2 control-label" htmlFor="email">
                        Correo Electrónico{" "}
                        <span style={{ color: "#fa0073" }}>*</span>
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="email"
                          className={`form-control ${
                            errors.email?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.email?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.email?.type === "validate"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.email?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.email?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="example@correo.com"
                          name="email"
                          type="text"
                          data-fv-field="email"
                          {...register("email", {
                            required: "El campo es requerido",
                            pattern: {
                              value:
                                /^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/,
                              message:
                                "Por favor introduce un correo electrónico válido",
                            },
                          })}
                          onChange={handleFormData}
                        />
                        {errors.email?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="email"
                            data-fv-result="INVALID"
                          >
                            {errors.email.message}
                          </small>
                        )}
                        {errors.email?.type === "pattern" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="email"
                            data-fv-result="INVALID"
                          >
                            {errors.email.message}
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group row mb-3 ">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="password"
                      >
                        Contraseña <span style={{ color: "#fa0073" }}>*</span>
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="password"
                          className={`form-control ${
                            errors.password?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.password?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.password?.type === "validatePassword"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.password?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.password?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="Contraseña"
                          name="password"
                          type="password"
                          data-fv-field="password"
                          {...register("password", {
                            required: "El campo es requerido",
                            maxLength: 16,
                            minLength: 6,
                            validate: {
                              validatePassword: (value) => {
                                const confirPass =
                                  document.getElementById(
                                    "password_confirm"
                                  ).value;

                                if (confirPass !== value) {
                                  return false;
                                }
                                return true;
                              },
                            },
                          })}
                          onChange={handleFormData}
                        />
                        {errors.password?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="password"
                            data-fv-result="INVALID"
                          >
                            {errors.password.message}
                          </small>
                        )}
                        {errors.password?.type === "validatePassword" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="password"
                            data-fv-result="INVALID"
                          >
                            La Contraseña y la Confirmación de la Contraseña
                            deben ser iguales
                          </small>
                        )}
                        {errors.password?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="password"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            6 y 16 caracteres
                          </small>
                        )}
                        {errors.password?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="password"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            6 y 16 caracteres
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group row mb-3 ">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="password_confirm"
                      >
                        Confirmacion de la Contraseña{" "}
                        <span style={{ color: "#fa0073" }}>*</span>
                      </label>
                      <div v className="col-sm-10">
                        <input
                          id="password_confirm"
                          className={`form-control ${
                            errors.password_confirm?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.password_confirm?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.password_confirm?.type === "validatePassword"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.password_confirm?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.password_confirm?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          placeholder="Confirmacion de la Contraseña"
                          name="password_confirm"
                          type="password"
                          data-fv-field="password_confirm"
                          {...register("password_confirm", {
                            required: "El campo es requerido",
                            maxLength: 16,
                            minLength: 6,
                            validate: {
                              validatePassword: (value) => {
                                const confirPass =
                                  document.getElementById("password").value;

                                if (confirPass !== value) {
                                  return false;
                                }
                                return true;
                              },
                            },
                          })}
                          onChange={handleFormData}
                        />
                        {errors.password_confirm?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="password_confirm"
                            data-fv-result="INVALID"
                          >
                            {errors.password_confirm.message}
                          </small>
                        )}
                        {errors.password_confirm?.type ===
                          "validatePassword" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="password_confirm"
                            data-fv-result="INVALID"
                          >
                            La Contraseña y la Confirmación de la Contraseña
                            deben ser iguales
                          </small>
                        )}
                        {errors.password_confirm?.type === "minLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="password_confirm"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            6 y 16 caracteres
                          </small>
                        )}
                        {errors.password?.type === "maxLength" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="password"
                            data-fv-result="INVALID"
                          >
                            Por favor introduce un valor con una longitud entre
                            6 y 16 caracteres
                          </small>
                        )}
                      </div>
                    </div>
                    <div className="form-group row mb-3 ">
                      <label
                        className="col-sm-2 control-label"
                        htmlFor="role_id"
                      >
                        Permisos <span style={{ color: "#fa0073" }}>*</span>
                      </label>
                      <div v className="col-sm-10">
                        <select
                          className={`form-control ${
                            errors.role_id?.type === "required"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.role_id?.type === "pattern"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.role_id?.type === "validate"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.role_id?.type === "maxLength"
                              ? "missing-field"
                              : ""
                          } ${
                            errors.role_id?.type === "minLength"
                              ? "missing-field"
                              : ""
                          }`}
                          name="role_id"
                          data-fv-field="role_id"
                          id="role_id"
                          {...register("role_id", {
                            required: "El campo es requerido",
                            pattern: /^(?!selected$).*$/,
                          })}
                          onChange={handleFormData}
                        >
                          <option selected="selected" value="selected">
                            Permisos
                          </option>
                          <option value="1">Administrador</option>
                          <option value="2">Usuario</option>
                          <option value="3">Tarifa</option>
                        </select>
                        {errors.role_id?.type === "required" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="role_id"
                            data-fv-result="INVALID"
                          >
                            El campo es requerido
                          </small>
                        )}
                        {errors.role_id?.type === "pattern" && (
                          <small
                            className="help-block"
                            data-fv-validator="notEmpty"
                            data-fv-for="role_id"
                            data-fv-result="INVALID"
                          >
                            El campo es requerido
                          </small>
                        )}
                      </div>
                    </div>
                  </div>
                  <nav>
                    <ul className="pagination pager wizard">
                      <li className="page-item previous disabled">
                        <a href="#" className="page-link">
                          Anterior
                        </a>
                      </li>
                      <li
                        className="page-item next ms-auto disabled hidden"
                        style={{ display: "none" }}
                      >
                        <a href="#" className="page-link">
                          Siguiente
                        </a>
                      </li>
                      <li className="page-item next finish ms-auto">
                        <button type="submit" className="page-link">
                          Finalizar
                        </button>
                      </li>
                    </ul>
                  </nav>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
}

export default AddUser;
